import { useUser } from "@clerk/clerk-react"

export const useAdminRoles = () => {
  const { user } = useUser()
  const adminRoles = (user?.publicMetadata as any)?.adminRole as
    | string[]
    | undefined
  return Array.isArray(adminRoles) ? adminRoles : []
}

export const useHasRole = (...roles: string[]) => {
  const adminRoles = useAdminRoles()
  return roles.some(r => adminRoles.includes(r))
}

export const useIsSuperAdmin = () => {
  return useHasRole("superadmin")
}

export const useCanTransfer = () => {
  return useHasRole("superadmin", "plumber")
}
